// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GWi37E9n4C4kymy1y2ro{width:100%}`, "",{"version":3,"sources":["webpack://./src/Components/Atoms/Skeleton/SkeletonTimeline/SkeletonTimeline.module.scss"],"names":[],"mappings":"AAAA,sBACI,UAAA","sourcesContent":[".Container {\n    width: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Container": `GWi37E9n4C4kymy1y2ro`
};
export default ___CSS_LOADER_EXPORT___;
